import { render, staticRenderFns } from "./ContentVars.vue?vue&type=template&id=67a1cabc&scoped=true&"
import script from "./ContentVars.vue?vue&type=script&lang=js&"
export * from "./ContentVars.vue?vue&type=script&lang=js&"
import style0 from "./ContentVars.vue?vue&type=style&index=0&id=67a1cabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1cabc",
  null
  
)

export default component.exports